<div class="v2-pagina cal-pagina">
    <div class="v2-inner">

        <div class="cal-encabezado">
            <div class="cal-icono"><i class="far fa-calendar-alt"></i></div>
            <div>
                <h1 class="cal-titulo">Calendario de juegos</h1>
                <p class="cal-subtitulo">Rol de juegos oficial de la Liga Infantil y Juvenil de Béisbol Yucatán A.C.</p>
            </div>
        </div>

        <div class="v2-tarjeta cal-filtros">
            <div class="cal-filtro">
                <i class="fas fa-filter cal-filtro-icono"></i>
                <span class="cal-filtro-texto">Categoría:</span>
                <select class="v2-select cal-select-categoria" [ngModel]="categoriaID" (ngModelChange)="seleccionarCategoria($event)">
                    <option *ngFor="let cat of Categorias" [ngValue]="+cat.CategoriaID">{{cat.Categoria}}</option>
                </select>
            </div>
            <div class="cal-navegacion">
                <button class="v2-boton-borde" (click)="jornadaAnterior()" [disabled]="jornadaIndex <= 0" title="Jornada anterior">
                    <i class="fas fa-chevron-left"></i><span class="cal-nav-texto">Anterior</span>
                </button>
                <select class="v2-select" [ngModel]="jornadaIndex" (ngModelChange)="seleccionarJornada($event)">
                    <option *ngFor="let jor of Jornadas; let i = index" [ngValue]="i">Jornada {{jor.Jornada}} — {{formatearFechaCorta(jor.Fecha)}}</option>
                </select>
                <button class="v2-boton-borde" (click)="jornadaSiguiente()" [disabled]="jornadaIndex >= Jornadas.length - 1" title="Jornada siguiente">
                    <span class="cal-nav-texto">Siguiente</span><i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>

        <div class="v2-tarjeta cal-jornada" *ngIf="jornadaSeleccionada">
            <div class="cal-jornada-encabezado">
                <div class="cal-jornada-titulos">
                    <span class="v2-badge-primario">Jornada {{jornadaSeleccionada.Jornada}}</span>
                    <span class="v2-badge-amarillo" *ngIf="esJornadaActual"><i class="fas fa-circle cal-punto"></i> En curso</span>
                </div>
                <span class="cal-jornada-fecha"><i class="far fa-calendar"></i> {{formatearFechaLarga(jornadaSeleccionada.Fecha)}}</span>
            </div>

            <div class="cal-aviso" *ngIf="cargando"><i class="fas fa-spinner fa-spin"></i> Cargando partidos...</div>

            <div class="cal-vacio" *ngIf="!cargando && Partidos.length === 0">
                <i class="fas fa-baseball-ball"></i>
                <p>No hay partidos registrados para esta categoría en esta jornada</p>
            </div>

            <div class="cal-partidos" *ngIf="!cargando && Partidos.length > 0">
                <div class="cal-partido" *ngFor="let partido of Partidos">
                    <div class="cal-partido-badges">
                        <span class="v2-badge">{{partido.ubicacion}}</span>
                        <span class="cal-estado" [ngClass]="partido.finalizado ? 'cal-estado-final' : 'cal-estado-programado'">
                            {{partido.finalizado ? 'Final' : 'Programado'}}
                        </span>
                    </div>
                    <div class="cal-partido-centro">
                        <div class="cal-equipo">
                            <img [src]="partido.equipo_1.logo || placeholderEquipo" (error)="onLogoError($event)" alt="" class="cal-logo">
                            <span class="cal-equipo-nombre" [class.cal-ganador]="partido.equipo_1.win">{{partido.equipo_1.equipo}}</span>
                        </div>
                        <div class="cal-marcador" *ngIf="partido.finalizado">
                            <span class="cal-carreras" [class.cal-ganador]="partido.equipo_1.win">{{partido.equipo_1.carreras}}</span>
                            <span class="cal-marcador-sep">–</span>
                            <span class="cal-carreras" [class.cal-ganador]="partido.equipo_2.win">{{partido.equipo_2.carreras}}</span>
                        </div>
                        <div class="cal-vs" *ngIf="!partido.finalizado">VS</div>
                        <div class="cal-equipo cal-equipo-derecha">
                            <span class="cal-equipo-nombre" [class.cal-ganador]="partido.equipo_2.win">{{partido.equipo_2.equipo}}</span>
                            <img [src]="partido.equipo_2.logo || placeholderEquipo" (error)="onLogoError($event)" alt="" class="cal-logo">
                        </div>
                    </div>
                    <p class="cal-cronica" *ngIf="partido.cronicas"><i class="fas fa-quote-left"></i> {{partido.cronicas}}</p>
                </div>
            </div>
        </div>

    </div>
</div>
